/**
 * Map Zoom SDK / app-context role strings to wire ClientRole.
 * Zoom uses camelCase (e.g. coHost) and hyphenated forms in different APIs.
 */
export function mapZoomRole(role) {
    if (role == null || role === '')
        return 'participant';
    const r = String(role).toLowerCase().replace(/_/g, '-');
    if (r === 'host')
        return 'host';
    if (r === 'co-host' || r === 'cohost')
        return 'co-host';
    // Webinar panelists can run the show; treat like co-host for control/roster.
    if (r === 'panelist')
        return 'co-host';
    if (r === 'participant' || r === 'attendee')
        return 'participant';
    return 'unknown';
}
//# sourceMappingURL=zoom-role.js.map